import { bindActionCreators } from 'redux';
import store from 'store';
import { actions as testActions } from 'store/modules/test';
import { actions as appActions } from 'store/modules/app';
import { actions as baseActions } from 'store/modules/base';
import { actions as authActions } from 'store/modules/auth';
import { actions as userActions } from 'store/modules/user';
import { actions as utilActions } from 'store/modules/util';
import { actions as employeeActions } from 'store/modules/employee';
import { actions as notificationActions } from 'store/modules/notification';
import { actions as dashboardActions } from 'store/modules/dashboard';
import { actions as partnerActions } from 'store/modules/partner';
import { actions as invoiceActions } from 'store/modules/invoice';
import { actions as projectActions } from 'store/modules/project';
import { actions as binActions } from 'store/modules/bin';
import { actions as fileActions } from 'store/modules/file';
import { actions as unitActions } from 'store/modules/unit';
import { actions as supportActions } from 'store/modules/support';
import { actions as storeActions } from 'store/modules/store';
import { actions as serialActions } from 'store/modules/serial';
import { actions as statisticsActions } from 'store/modules/statistics';
import { actions as patientActions } from 'store/modules/patient';
import { actions as pmsActions } from 'store/modules/pms';

export const { dispatch } = store;

export const TestActions: typeof testActions = bindActionCreators(testActions, dispatch);
export const AppActions: typeof appActions = bindActionCreators(appActions, dispatch);
export const AuthActions: typeof authActions = bindActionCreators(authActions, dispatch);
export const BaseActions: typeof baseActions = bindActionCreators(baseActions, dispatch);
export const UserActions: typeof userActions = bindActionCreators(userActions, dispatch);
export const UtilActions: typeof utilActions = bindActionCreators(utilActions, dispatch);
export const EmployeeActions: typeof employeeActions = bindActionCreators(
  employeeActions,
  dispatch,
);
export const NotificationActions: typeof notificationActions = bindActionCreators(
  notificationActions,
  dispatch,
);
export const DashboardActions: typeof dashboardActions = bindActionCreators(
  dashboardActions,
  dispatch,
);
export const PartnerActions: typeof partnerActions = bindActionCreators(partnerActions, dispatch);
export const InvoiceActions: typeof invoiceActions = bindActionCreators(invoiceActions, dispatch);
export const ProjectActions: typeof projectActions = bindActionCreators(projectActions, dispatch);
export const BinActions: typeof binActions = bindActionCreators(binActions, dispatch);
export const FileActions: typeof fileActions = bindActionCreators(fileActions, dispatch);
export const UnitActions: typeof unitActions = bindActionCreators(unitActions, dispatch);
export const SupportActions: typeof supportActions = bindActionCreators(supportActions, dispatch);
export const StoreActions: typeof storeActions = bindActionCreators(storeActions, dispatch);
export const SerialActions: typeof serialActions = bindActionCreators(serialActions, dispatch);
export const StatisticsActions: typeof statisticsActions = bindActionCreators(
  statisticsActions,
  dispatch,
);
export const PatientActions: typeof patientActions = bindActionCreators(patientActions, dispatch);

export const PmsActions: typeof pmsActions = bindActionCreators(pmsActions, dispatch);
// export const DispatchActions = {
//   ...TestActions,
//   ...AppActions,
//   ...BaseActions,
//   ...AuthActions,
//   ...UserActions,
// };
